import { Colors } from '@/components/ui/types';
import { ActivityCorrectionStatusEnum } from '@/models/ActivityProgress';

export const activityCorrectionStatusColors: Record<
  ActivityCorrectionStatusEnum,
  Colors
> = {
  [ActivityCorrectionStatusEnum.NOT_SUBMITTED]: 'neutral',
  [ActivityCorrectionStatusEnum.PENDING]: 'warning',
  [ActivityCorrectionStatusEnum.CORRECTED]: 'success',
};
